import { connect } from 'react-redux';
import {
  changePasswordAsync,
  fetchNotificationSettingsAsync,
  notificationSettingsSelector,
  saveNotificationSettingsAsync,
  sessionUserEmailSelector,
} from '../../../lib/dataLayer';
import { isLoadingSelector } from '../../../store/app/selectors';
import SettingsPage from '../components/SettingsPage';

const mapStateToProps = state => ({
  notificationSettings: notificationSettingsSelector(state),
  email: sessionUserEmailSelector(state),
  isLoading: isLoadingSelector(state),
});

const mapDispatchToProps = {
  onChangePassword: changePasswordAsync,
  onMount: fetchNotificationSettingsAsync,
  onSaveNotifications: saveNotificationSettingsAsync,
};

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(SettingsPage);



// WEBPACK FOOTER //
// ./src/modules/SettingsPage/containers/SettingsContainer.js